import { portalRoutes } from "./portalRoutes";
import { accountRoutes } from "./accountRoutes";
import { adminRoutes } from "./adminRoutes";
import elecIndex  from "./index.electron.js";

const isElectron = window.IS_ELECTRON;
export const Routes = isElectron? [...elecIndex] :  [
        ...portalRoutes,
        //...dashboardRoutes,
        // ...corporateRoutes,
        // ...userProfileRoutes,
        ...accountRoutes,
        //...errorRoutes,
        // ...aboutRoutes,
        ...adminRoutes,
];

export default Routes;
